import { render, staticRenderFns } from "./navEdit.vue?vue&type=template&id=58dcfe7e&scoped=true&"
import script from "./navEdit.vue?vue&type=script&lang=js&"
export * from "./navEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dcfe7e",
  null
  
)

export default component.exports